import React, { useState, useEffect } from "react";
import injectSheet from "react-jss";
import axios from "axios";
import Functions from "../../../utils/Functions";
import { Link } from "react-router-dom";
import Dots from "../../Loaders/Dots";
import GetData from "../../../utils/axios/GetData";

const MenuItem = ({
  view,
  listtype,
  classes,
  toggleMobileMenu,
  toggleSubmenu,
}) => {
  const [totalCount, setTotalCount] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const source = axios.CancelToken.source();
    async function fetchData() {
      const data = await GetData("/arrangemangs/count", source, {
        view: view,
        listtype: listtype,
      });
      if (data) {
        setTotalCount(data.result);
        setIsLoading(false);
      }
    }

    fetchData();

    return () => {
      source.cancel();
    };
  }, [view, listtype]);

  return (
    <Link
      className={classes.link}
      to={Functions.getUrlFromView(view, listtype)}
      onClick={() => {
        if (toggleSubmenu) toggleSubmenu();
        if (toggleMobileMenu) toggleMobileMenu();
      }}
    >
      <span>{Functions.getLabelFromView(view)} </span>
      <span>({isLoading ? <Dots color="white" /> : totalCount})</span>
    </Link>
  );
};

const styles = {
  link: {
    "&::first-letter": {
      textTransform: "uppercase",
    },
  },
};
export default injectSheet(styles)(MenuItem);
